import { render, staticRenderFns } from "./change_program.vue?vue&type=template&id=a5385236&scoped=true&"
import script from "./change_program.vue?vue&type=script&lang=js&"
export * from "./change_program.vue?vue&type=script&lang=js&"
import style0 from "./change_program.vue?vue&type=style&index=0&id=a5385236&lang=scss&scoped=true&"
import style1 from "./change_program.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5385236",
  null
  
)

export default component.exports